module.exports = __webpack_public_path__ + "static/img/conmiss.2ad5682.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/conmiss.jpg
// module id = eAQy
// module chunks = 31